import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index'

import LandlordLoginView from '../views/Landlord/Auth/LandlordLogin.vue'
import LandlordLayoutView from '../views/Landlord/LandlordLayout.vue'
import LandlordDashboardView from '../views/Landlord/Dashboard/LandlordDashboard.vue'
import LandlordTenantsIndexView from '../views/Landlord/Tenants/Index.vue'
import LandlordTenantView from '../views/Landlord/Tenants/View.vue'
import LandlordTenantCreateView from '../views/Landlord/Tenants/Create.vue'
import LandlordSocietiesIndexView from '../views/Landlord/Societies/Index.vue'
import LandlordSocietyView from '../views/Landlord/Societies/View.vue'
import LandlordModulesIndexView from '../views/Landlord/Modules/Index.vue'
import LandlordPlansIndexView from '../views/Landlord/Plans/Index.vue'
import LandlordPlanView from '../views/Landlord/Plans/View.vue'
import LandlordTicketsIndexView from '../views/Landlord/Tickets/Index.vue'
import LandlordLoginLogsView from '../views/Landlord/LoginLogs/Index.vue'
import LandlordSettingsLayoutView from '../views/Landlord/Settings/Layout/BaseSettingLayout.vue'
import LandlordSettingsSupportView from '../views/Landlord/Settings/Support.vue'
import LayoutLoginView from '../views/Auth/LayoutLogin.vue'
import ConnexionView from '../views/Auth/Connexion.vue'
import ForgotPasswordView from '../views/Auth/ForgotPassword.vue'
import CreatePasswordView from '../views/Auth/CreatePassword.vue'
import ResetPasswordView from '../views/Auth/ResetPassword.vue'
import CreateAccountView from '../views/Auth/CreateAccount.vue'
import PermissionDeniedView from '../views/Auth/PermissionDenied.vue'
import NotFoundPageView from '../views/NotFoundPage.vue'
import CguView from '../views/Auth/Cgu.vue'


import LayoutBasicView from '@/views/Layouts/LayoutBasic'
import DashboardView from "@/views/Dashboard/Dashboard.vue"
import GeneralInformation from "@/views/GeneralInformation/GeneralInformation.vue"
import StatistiqueSaleView from "@/views/Statistique/Vente.vue"
import StatistiqueUserView from "@/views/Statistique/User.vue"
import StatistiqueCategoryView from "@/views/Statistique/Category.vue"
import StatistiqueRentabiliteView from "@/views/Statistique/Rentabilite.vue"
import RapportsHubView from "@/views/Rapports/Hub.vue"
import RapportsViewerView from "@/views/Rapports/ReportViewer.vue"
import MyTicketsView from "@/views/Support/MyTickets.vue"
import ShopAddProductsView from "@/views/Shop/AddProducts.vue";


import FactureNormaliseeConfigView from "@/views/Settings/Invoice/Invoice_config.vue"
import SocietyConfigView from "@/views/Settings/Society/Config.vue"


import ContactDetailView from "@/views/Contact/View";
import ContactIndexView from "@/views/Contact/Index.vue"

import CodePromoIndexView from "@/views/Promo/Index";


import ShopIndexView from "@/views/Shop/Index";
import ShopDetailsView from "@/views/Shop/View";
import ShopProductsView from "@/views/Shop/Products";
import ShopPromotionsView from "@/views/Shop/Promotion";
import ShopPromotionDetailView from '@/views/Shop/PromotionDetail.vue'
import ShopLoyaltyView from '@/views/Shop/Loyalty.vue'
import ShopCreditsView from '@/views/Shop/Credits.vue'
import LoyaltyIndexView from '@/views/Loyalty/Index.vue'
import LoyaltyDetailView from '@/views/Loyalty/Detail.vue'
import LoyaltyMembersView from '@/views/Loyalty/Members.vue'
import LoyaltyMemberDetailView from '@/views/Loyalty/MemberDetail.vue'
import ShopProductsEndedView from "@/views/Shop/ProductsEnded";
import ShopStagnantProductsView from "@/views/Shop/StagnantProducts";
import ShopUsersView from "@/views/Shop/Users";
import ShopBoxesView from "@/views/Shop/Box";
import ShopEntriesView from "@/views/Shop/Entry";
import ShopEntriesUnconformView from "@/views/Shop/EntryUnconform";
import ShopStoreOutputView from "@/views/Shop/StoreOutput";
import ShopValidateEntrytView from "@/views/Shop/ValidateEntry";
import ShopDetailsEntryView from "@/views/Shop/DetailsEntry";
import ShopOrdersView from "@/views/Shop/Order";
import ShopConfigurationStoresView from "@/views/Shop/ConfigurationStores";
import SessionView from "@/views/Shop/Session/Index.vue"
import DetailsSession  from "@/views/Shop/Session/Details.vue";
import SessionSales  from "@/views/Shop/Session/Sales.vue";
import SessionSalesByProduct  from "@/views/Shop/Session/SaleByProduct.vue";


import ShopCreateOutputView from "@/views/Shop/MoveCreate"
import ShopOrderDetails from "@/views/Shop/OrderDetails"
import ShopUpdateOutputView from "@/views/Shop/MoveContent"
import ShopBarcodeView from "@/views/Shop/Barcode"

import StoreView from "@/views/Settings/Stores/Index";
import StoreViewDetail from "@/views/Settings/Stores/Store";
import StoreViewProduct from "@/views/Settings/Stores/Product";
import StoreViewEntrie from "@/views/Settings/Stores/Entrie";
import StoreViewEntrieCreate from "@/views/Settings/Stores/EntrieCreate";
import StoreViewOutput from "@/views/Settings/Stores/Output";
import StoreViewOutputCreate from "@/views/Settings/Stores/OutputCreate";
import StoreViewOutputContent from "@/views/Settings/Stores/OutputContent";
import StoreViewUser from "@/views/Settings/Stores/User";
import StoreUnvalidEntry from "@/views/Settings/Stores/UnvalidEntry";
import StoreViewUnvalidEntry from "@/views/Settings/Stores/UnvalidEntryView";

import BundleUpdateView  from "@/views/Bundle/View";
import BundleIndexView from "@/views/Bundle/Index.vue";
import PromotionIndexView from '@/views/Promotion/Index.vue'
import PromotionDetailView from '@/views/Promotion/Detail.vue'
import SuppliersPurchasesIndexView  from "@/views/SupplierPurchase/Index.vue";
import SuppliersPurchasesDetailView  from "@/views/SupplierPurchase/Detail.vue";
import SuppliersPurchasesShowView  from "@/views/SupplierPurchase/Show.vue";
import SuppliersPurchasesValidateView  from "@/views/SupplierPurchase/Validate.vue";

import ReviewView from "@/views/E-commerce/Review/Index.vue";
import CommandesView from "@/views/E-commerce/Commandes/Commandes";
import DestockageView from "@/views/E-commerce/Commandes/Destockage";
import EcommerceProductsView from "@/views/E-commerce/Products/Index.vue";
import MesLivraisonsView from "@/views/E-commerce/Livraisons/MesLivraisons.vue";
import ToutesLivraisonsView from "@/views/E-commerce/Livraisons/ToutesLivraisons.vue";
import ConditionIndexView from "@/views/Settings/Condition/Index.vue";
import axios from 'axios';
import { PLATFORM_THEMED_CLASS } from '@/composables/usePlatformColor'



const routes = [

    {
        path: '/register',
        component: CreateAccountView,
        name: 'register',
        meta: { redirectIfAuthenticated: true },
    },
    {
        path: '/termes-and-conditions',
        component: CguView,
        meta: {
            redirectIfAuthenticated: false
        },
    },


    {
        path: '/',
        component: LayoutLoginView,
        children: [
            {
                path: '/',
                component: ConnexionView,
                meta: { redirectIfAuthenticated: true },
            },
            {
                path: 'login',
                name: 'login',
                component: ConnexionView,
                meta: { redirectIfAuthenticated: true },
            },
            {
                path: 'confirm/:id/:token/create_password',
                component: CreatePasswordView,
                name: 'create-password',
                meta: { redirectIfAuthenticated: false },
            },

            {
                path: 'forgot-password',
                component: ForgotPasswordView,
                name: 'forgot-password',
                meta: { redirectIfAuthenticated: true },
            },
            {
                path: 'reset/:token/password',
                component: ResetPasswordView,
                name: 'reset-password',
                meta: { redirectIfAuthenticated: true },
            }
        ]

    },
    /*
    |--------------------------------------------------------------------------
    | Admin Backend Routes
    |--------------------------------------------------------------------------|
    */
    {
        path: '/admin',
        component: LayoutBasicView, // Change the desired Layout here
        meta: { requiresAuth: false },
        children: [
            // Dashbord
            {
                path: '/',
                component: DashboardView,
                name: 'dashboard',
                meta: { requiresPermission: 'dashboard_view' },
            },
            {
                path: 'dashboard',
                component: DashboardView,
                name: 'dashboard-path',
                meta: { requiresPermission: 'dashboard_view' },
            },
            // Accueil : destination des utilisateurs sans accès au tableau de bord (raccourcis
            // vers leurs sections) — aucune permission requise
            {
                path: 'home',
                component: () => import('../views/Home/Home.vue'),
                name: 'home',
            },
            {
                path: 'general',
                component: GeneralInformation,
                name: 'general-path',
                meta: { requiresPermission: 'general_information_view' },
            },
            {
                path: 'statistique/user',
                component: StatistiqueUserView,
                name: 'statistique-user-path',
                meta: { requiresPermission: 'statistic_view' },
            },
            {
                path: 'statistique/products',
                component: StatistiqueCategoryView,
                name: 'statistique-category-path',
                meta: { requiresPermission: 'statistic_view' },
            },
            {
                path: 'statistique/sale',
                component: StatistiqueSaleView,
                name: 'statistique-sale-path',
                meta: { requiresPermission: 'statistic_view' },
            },
            {
                path: 'statistique/rentabilite',
                component: StatistiqueRentabiliteView,
                name: 'statistique-rentabilite-path',
                meta: { requiresPermission: 'statistic_view', requiresModule: 'pos.stock' },
            },
            {
                path: 'rapports',
                component: RapportsHubView,
                name: 'rapports-hub-path',
                meta: { requiresPermission: 'report_view', requiresModule: 'reports' },
            },
            {
                path: 'rapports/:slug',
                component: RapportsViewerView,
                name: 'rapports-viewer-path',
                meta: { requiresPermission: 'report_view', requiresModule: 'reports' },
            },
            {
                path: 'support-tickets',
                component: MyTicketsView,
                name: 'my-tickets-path',
            },
            // Mon profil : page à part, hors Paramètres (nom de route gardé pour les liens existants)
            {
                path: 'profil',
                component: () => import('../views/Profile/ProfilePage.vue'),
                name: 'settings-profile',
                meta: { title: 'setting.profil' },
            },


            //contacts
            {
                path: 'contacts',
                component: ContactIndexView,
                name: 'contacts-path',
                meta: { requiresPermission: 'customer_view' },
            },

            {
                path: 'contact/:id/view',
                component: ContactDetailView,
                name: 'contact-view-path',
                meta: { requiresPermission: 'customer_view' },

            },



            //shops
            {
                path: 'shops/:id/view/validate/entry',
                component: ShopValidateEntrytView,
                name: 'shop-validate-entry',
                meta: { requiresPermission: 'boutique_transfert_validate', requiresModule: 'pos.stock' },
            },

            // Magasins (société) : pages pleine largeur, comme les boutiques — module pos.warehouse
            {
                path: "stores",
                component: () => import('@/views/Settings/Stores/StoresLayout.vue'),
                meta: {
                    title: 'setting.stores',
                    breadcrumbs: [
                        {
                            name: 'breadcrumbs.setting.setting',
                            routeName: 'settings-new'
                        }
                    ],
                },
                children: [
                    {
                        path: '',
                        component: StoreView,
                        name: 'settings-stores',
                        meta: { requiresPermission: 'magasin_view', requiresModule: 'pos.warehouse' },
                    },
                    {
                        path: ':id/views',
                        component: StoreViewDetail,
                        name: 'store-data-path',
                        meta: {
                            title: 'setting.stores',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ]
                        },
                        children: [
                            {
                                path: '',
                                component: StoreViewProduct,
                                name: 'store-details',
                                meta: { requiresPermission: 'product_magasin_view', requiresModule: 'pos.warehouse' },
                            },
                            {
                                path: 'product',
                                component: StoreViewProduct,
                                name: 'store-details-product',
                                meta: { requiresPermission: 'product_magasin_view', requiresModule: 'pos.warehouse' },
                            },
                            {
                                path: 'entries',
                                component: StoreViewEntrie,
                                name: 'store-details-entries',
                                meta: { requiresPermission: 'product_magasin_transfert_view', requiresModule: 'pos.warehouse' },
                            },
                            // Entrées / transferts : affichés dans la fiche (menu gauche conservé)
                            {
                                path: 'entries/create',
                                component: StoreViewEntrieCreate,
                                name: 'store-entries-create',
                                meta: { requiresPermission: 'entry_magasin_create', requiresModule: 'pos.warehouse' },
                            },
                            // Ancienne page de modification d'une entrée (API supprimée) :
                            // les entrées se gèrent désormais depuis la liste
                            {
                                path: 'entries/:id_content/content',
                                redirect: { name: 'store-details-entries' },
                            },
                            {
                                path: 'output/create',
                                component: StoreViewOutputCreate,
                                name: 'store-output-create',
                                meta: { requiresPermission: 'output_magasin_create', requiresModule: 'pos.warehouse' },
                            },
                            {
                                path: 'output/:id_content/content',
                                component: StoreViewOutputContent,
                                name: 'store-output-content',
                                meta: { requiresPermission: 'output_magasin_view', requiresModule: 'pos.warehouse' },
                            },
                            {
                                path: 'output',
                                component: StoreViewOutput,
                                name: 'store-details-output',
                                meta: { requiresPermission: 'output_magasin_view', requiresModule: 'pos.warehouse' },
                            },
                            {
                                path: 'user',
                                component: StoreViewUser,
                                name: 'store-details-user',
                                meta: { requiresPermission: 'user_magasin_view', requiresModule: 'pos.warehouse' },
                            },
                            {
                                path: 'update',
                                component: StoreViewUser,
                                name: 'store-details-update',
                                meta: { requiresPermission: 'user_magasin_update', requiresModule: 'pos.warehouse' },
                            },
                            {
                                // inventaires du magasin : mêmes écrans que la boutique (meta inventoryTarget)
                                path: 'inventories',
                                component: () => import('@/views/Shop/Inventories'),
                                name: 'store-inventories',
                                meta: { requiresPermission: 'inventory_magasin_view', requiresModule: 'pos.warehouse', inventoryTarget: 'store' },
                            },
                            {
                                path: 'inventories/:inventoryId',
                                component: () => import('@/views/Shop/InventoryDetail'),
                                name: 'store-inventory-detail',
                                meta: { requiresPermission: 'inventory_magasin_view', requiresModule: 'pos.warehouse', inventoryTarget: 'store' },
                            },
                            {
                                path: 'entry/unvalided',
                                component: StoreUnvalidEntry,
                                name: 'store-details-unvalide-entry',
                                meta: {requiresPermission: 'no_validate_entry_view', requiresModule: 'pos.warehouse'},
                            },
                            {
                                path: 'entry/:entry_id/unvalidated/view',
                                component: StoreViewUnvalidEntry,
                                name: 'store-unvalid-entry-view',
                                meta: {requiresPermission: 'no_validate_entry_view', requiresModule: 'pos.warehouse'},
                            }
                        ]
                    },
                ]
            },

            //shops
            {
                path: 'shops',
                component: ShopIndexView,
                name: 'shop-index',
                meta: { requiresPermission: 'boutique_view' },
            },
            {
                path: 'shops/:id/view/validate/:output_id/entry',
                component: ShopValidateEntrytView,
                name: 'shop-validate-entry',
                meta: { requiresPermission: 'boutique_view', requiresModule: 'pos.stock' },
            },
            {
                path: 'shops/:id/view/:entry_id/details',
                component: ShopDetailsEntryView,
                name: 'shop-detail-entry',
                meta: { requiresPermission: 'boutique_view', requiresModule: 'pos.stock' },
            },
            {
                path: 'shops/:id/view',
                component: ShopDetailsView,
                name: 'shop-details',
                children: [
                    {
                        path: '',
                        component: ShopProductsView,
                        name: 'shop-detail-products',
                        meta: { requiresPermission: ['product_boutique_view', 'boutique_view'] },
                        // requiresPermission ci-dessus est volontairement en "OU" (boutique_view
                        // suffit pour ATTEINDRE la fiche boutique) — mais la page par défaut
                        // affichée ici est la liste des produits, qui elle exige vraiment
                        // product_boutique_view côté API. Un utilisateur avec seulement
                        // boutique_view passait le garde puis plantait sur les données. On le
                        // redirige donc vers la première section du menu qu'il peut réellement
                        // utiliser, dans le même ordre que le menu latéral (Shop/View.vue).
                        beforeEnter: async (to, from, next) => {
                            // F5 / URL directe : les permissions ne sont chargées que plus tard
                            // (LayoutBasic) — sans ça, liste vide et 403 systématique au rechargement.
                            if (!(store.getters['permission/permissions'] || []).length) {
                                try { await store.dispatch('permission/loadPermissions') } catch {}
                            }
                            // rôle par boutique : son rôle propre à CETTE boutique s'ajoute au rôle général
                            const perms = (store.getters['permission/permissions'] || [])
                                .concat(store.getters['permission/shopPermissions']?.[to.params.id] || [])
                            if (perms.includes('product_boutique_view')) return next()

                            const fallbackOrder = [
                                'user_boutique_view:shop-users',
                                'sale_boutique_view:shop-orders',
                                'box_view:shop-boxes',
                                'entry_boutique_view:shop-entries',
                                'boutique_transfert_view:shop-moves',
                                'inventory_boutique_view:shop-inventories',
                                'loyalty_program_view:shop-loyalty',
                            ]
                            for (const entry of fallbackOrder) {
                                const [perm, name] = entry.split(':')
                                if (perms.includes(perm)) {
                                    return next({ name, params: to.params })
                                }
                            }
                            return next('/admin/permission-denied/403')
                        },
                    },
                    {
                        path: 'products',
                        component: ShopProductsView,
                        name: 'shop-products',
                        meta: { requiresPermission: 'product_boutique_view' },
                    },
                    {
                        path: 'promotions',
                        component: ShopPromotionsView,
                        name: 'shop-promotions',
                        meta: { requiresPermission: 'product_boutique_view', requiresModule: 'ecommerce.promotions' },
                    },
                    {
                        // création sur la page détail (plus de fenêtre de création)
                        path: 'promotion/new',
                        name: 'shop-promotion-create',
                        component: ShopPromotionDetailView,
                        meta: { requiresPermission: 'promotion_create', requiresModule: 'ecommerce.promotions' },
                    },
                    {
                        path: 'promotion/:promotionId/detail',
                        name: 'shop-promotion-detail',
                        component: ShopPromotionDetailView,
                        meta: { requiresPermission: 'promotion_view', requiresModule: 'ecommerce.promotions' },
                    },
                    {
                        path: 'loyalty',
                        component: ShopLoyaltyView,
                        name: 'shop-loyalty',
                        meta: { requiresPermission: 'loyalty_program_view', requiresModule: 'loyalty' },
                    },
                    {
                        path: 'products/outOfStock',
                        component: ShopProductsEndedView,
                        name: 'shop-products-ended',
                        meta: { requiresPermission: 'product_boutique_view', requiresModule: 'pos.stock' },
                    },
                    {
                        path: 'products/stagnant',
                        component: ShopStagnantProductsView,
                        name: 'shop-products-stagnant',
                        meta: { requiresPermission: 'product_boutique_view', requiresModule: 'pos.stock' },
                    },
                    {
                        path: 'add/products',
                        component: ShopAddProductsView,
                        name: 'shop-add-products',
                        meta: { requiresPermission: 'product_boutique_view' },
                    },

                    {
                        path: 'configuration/stores',
                        component: ShopConfigurationStoresView,
                        name: 'shop-config-stores',
                        meta: { requiresPermission: 'boutique_store_config_view', requiresModule: 'pos.warehouse' },
                    },
                    {
                        path: 'media',
                        component: () => import('@/views/Settings/EcomMedia/Index'),
                        name: 'shop-media',
                        meta: { requiresModule: 'ecommerce' },
                    },
                    {
                        path: 'media-list',
                        component: () => import('@/views/Settings/EcomMedia/MediaList'),
                        name: 'shop-media-list',
                        meta: { requiresPermission: 'section_view', requiresModule: 'ecommerce' },
                    },
                    {
                        // Coordonnées et identité : désormais dans la fenêtre « Modifier la boutique »
                        path: 'branding',
                        name: 'shop-branding',
                        redirect: to => ({ name: 'shop-detail-products', params: to.params }),
                    },
                    {
                        path: 'users',
                        component: ShopUsersView,
                        name: 'shop-users',
                        meta: { requiresPermission: 'user_boutique_view' },
                    },
                    {
                        path: 'boxes',
                        component: ShopBoxesView,
                        name: 'shop-boxes',
                        meta: { requiresPermission: 'box_view' },

                    },
                    {
                        path: 'barcodes',
                        component: ShopBarcodeView,
                        name: 'shop-barcode',
                        meta: { requiresPermission: 'product_boutique_view', requiresModule: 'pos.stock' },
                    },
                    {
                        path: 'entries',
                        component: ShopEntriesView,
                        name: 'shop-entries',
                        meta: { requiresPermission: 'entry_boutique_view', requiresModule: 'pos.stock' },
                    },
                    {
                        path: 'inventories',
                        component: () => import('@/views/Shop/Inventories'),
                        name: 'shop-inventories',
                        meta: { requiresPermission: 'inventory_boutique_view', requiresModule: 'pos.stock' },
                    },
                    {
                        path: 'inventories/:inventoryId',
                        component: () => import('@/views/Shop/InventoryDetail'),
                        name: 'shop-inventory-detail',
                        meta: { requiresPermission: 'inventory_boutique_view', requiresModule: 'pos.stock' },
                    },
                    {
                        path: 'moves',
                        component: () => import('@/views/Shop/Move'),
                        name: 'shop-moves',
                        meta: { requiresPermission: 'boutique_transfert_view', requiresModule: 'pos.stock' },
                    },
                    {
                        path: 'entries/no_conform',
                        component: ShopEntriesUnconformView,
                        name: 'shop-entries-unconform',
                        meta: { requiresPermission: 'no_conform_entry_boutique_view', requiresModule: 'pos.stock' },
                    },
                    {
                        path: 'outputs',
                        component: ShopStoreOutputView,
                        name: 'shop-store-output',
                        // demande de stock à un magasin : module Magasins
                        meta: { requiresPermission: 'output_boutique_view', requiresModule: 'pos.warehouse' },
                    },
                    {
                        path: 'orders',
                        component: ShopOrdersView,
                        name: 'shop-orders',
                        meta: { requiresPermission: 'sale_boutique_view' },
                    },
                    {
                        path: 'credits',
                        component: ShopCreditsView,
                        name: 'shop-credits',
                        meta: { requiresPermission: 'credit_view', requiresModule: 'pos.sales' },
                    },
                    {
                        path: 'orders/:detail_id/detail',
                        component: ShopOrderDetails,
                        name: 'order-details',
                        meta: { requiresPermission: 'sale_detail_boutique_view' },
                    },
                    {
                        path: 'moves/create/output',
                        component: ShopCreateOutputView,
                        name: 'shop-create-output',
                        meta: { requiresPermission: 'output_boutique_create', requiresModule: 'pos.stock' },
                    },
                    {
                        path: 'moves/update/:id_content/output',
                        component: ShopUpdateOutputView,
                        name: 'shop-update-output',
                        meta: { requiresPermission: 'output_boutique_update', requiresModule: 'pos.stock' },
                    },
                    {
                        path: 'session',
                        component:  SessionView,
                        name: 'session-path',
                        meta: { requiresPermission: 'boutique_session_view' },
                    },

                    {
                        path: 'session/:sessionId/details',
                        component: DetailsSession ,
                        name: 'session-details',

                        children : [
                            {
                                path: '',
                                component:  SessionSales,
                                name: 'session-details-default',
                                meta: { requiresPermission: 'boutique_session_sale' },
                            },
                            {
                                path: 'sales',
                                component: SessionSales ,
                                name: 'session-sales-path',
                                meta: { requiresPermission: 'boutique_session_sale' },
                            },
                            {
                                path: 'products',
                                component: SessionSalesByProduct ,
                                name: 'session-products-path',
                                meta: { requiresPermission: 'boutique_session_product' },
                            },
                        ]
                    },

                ]
            },

            //code-promo
            {
                path: 'code-promo',
                component:  CodePromoIndexView,
                name: 'code-promo-index',
                meta: { requiresPermission: 'code_promo_view', requiresModule: 'ecommerce.promo_codes' },
            },
            {
                // détail d'un code promo : réglages, utilisation, commandes et clients
                path: 'code-promo/:id/detail',
                component: () => import('@/views/Promo/Detail.vue'),
                name: 'code-promo-detail',
                meta: { requiresPermission: 'code_promo_view', requiresModule: 'ecommerce.promo_codes' },
            },

            //supplier
            {
                path: 'suppliers/purchases',
                children: [
                    {
                        path: '',
                        component:  SuppliersPurchasesIndexView,
                        name: 'suppliers-purchases',
                        meta: { requiresPermission: 'customer_view' },
                    },
                    {
                        path: 'create',
                        component:  SuppliersPurchasesDetailView,
                        name: 'suppliers-purchases-create',
                        meta: { requiresPermission: 'customer_view' },
                    },
                    {
                        path: 'edit/:id',
                        component:  SuppliersPurchasesDetailView,
                        name: 'suppliers-purchases-edit',
                        meta: { requiresPermission: 'customer_view' },
                    },
                    {
                        path: 'view/:id',
                        children: [
                            {
                                path: '',
                                component:  SuppliersPurchasesShowView,
                                name: 'suppliers-purchases-view',
                                meta: { requiresPermission: 'customer_view' },
                            },
                            {
                                path: 'validate',
                                component:  SuppliersPurchasesValidateView,
                                name: 'suppliers-purchases-validate',
                                meta: { requiresPermission: 'customer_view' },
                            }
                        ]
                    }
                ]
            },


            //Promotions
            {
                path: 'promotions',
                name: 'promotions',
                component: PromotionIndexView,
                meta: { requiresPermission: 'promotion_view', requiresModule: 'ecommerce.promotions' },
            },
            {
                // création sur la page détail (plus de fenêtre de création)
                path: 'promotion/new',
                name: 'promotion-create',
                component: PromotionDetailView,
                meta: { requiresPermission: 'promotion_create', requiresModule: 'ecommerce.promotions' },
            },
            {
                path: 'promotion/:id/detail',
                name: 'promotion-detail',
                component: PromotionDetailView,
                meta: { requiresPermission: 'promotion_view', requiresModule: 'ecommerce.promotions' },
            },
            //Fidélité
            {
                path: 'loyalty-programs',
                name: 'loyalty-programs',
                component: LoyaltyIndexView,
                meta: { requiresPermission: 'loyalty_program_view', requiresModule: 'loyalty' },
            },
            {
                path: 'loyalty-program/:programId/detail',
                name: 'loyalty-program-detail',
                component: LoyaltyDetailView,
                meta: { requiresPermission: 'loyalty_program_view', requiresModule: 'loyalty' },
            },
            {
                path: 'loyalty-members',
                name: 'loyalty-members',
                component: LoyaltyMembersView,
                meta: { requiresPermission: 'loyalty_program_view', requiresModule: 'loyalty' },
            },
            {
                path: 'loyalty-member/:memberId/detail',
                name: 'loyalty-member-detail',
                component: LoyaltyMemberDetailView,
                meta: { requiresPermission: 'loyalty_program_view', requiresModule: 'loyalty' },
            },
            //e-commerce
            {
                path: 'ecommerce/orders',
                component: CommandesView,
                name: 'ecommerce-commandes-path',
                meta: { requiresPermission: 'order_view', requiresModule: 'ecommerce' },
            },

            {
                path: 'ecommerce/orders/:id/view/destockage',
                component: DestockageView,
                name: 'ecommerce-destockage-path',
                meta: { requiresPermission: 'order_view', requiresModule: 'ecommerce' },
            },
            {
                path: 'ecommerce/my-deliveries',
                component: MesLivraisonsView,
                name: 'ecommerce-my-deliveries',
                meta: { requiresPermission: 'delivery_view', requiresModule: 'ecommerce' },
            },
            {
                path: 'ecommerce/deliveries',
                component: ToutesLivraisonsView,
                name: 'ecommerce-all-deliveries',
                meta: { requiresPermission: 'all_deliveries_view', requiresModule: 'ecommerce' },
            },
            {
                path: 'ecommerce/reviews',
                component: ReviewView,
                name: 'review-path',
                meta: { requiresPermission: 'rating_view', requiresModule: 'ecommerce' },
            },
            {
                path: 'ecommerce/products',
                component: EcommerceProductsView,
                name: 'products-path',
                meta: { requiresModule: 'ecommerce' },
            },
            {
                path: 'ecommerce/catalogue',
                component: () => import('../views/E-commerce/Catalogue.vue'),
                name: 'ecommerce-catalogue-path',
                meta: { requiresPermission: 'product_view', requiresModule: 'ecommerce' },
            },
            //settings

            //setting
            {
                path: 'settings',
                name: 'settings',
                component: () => import('../views/Settings/Index.vue'),
                meta: { requiresAuth: true, requiresPermission: 'setting_view' },
            },
            {
                name: "settings-new",
                path: "settings-user",
                component: () => import('../views/Settings/Layout/BaseSettingLayout.vue'),
                children: [
                    {
                        path: "",
                        name: "settings-users",
                        component: () => import('../views/Settings/User/User.vue'),
                        meta: {
                            title: 'setting.users',
                            computedBreadcrumbs: (route) => {
                                return [
                                    {
                                        name: 'breadcrumbs.product.list',
                                        routeName: 'settings-items'
                                    },
                                    {
                                        name: route.query.product ? 'breadcrumbs.product.details' : 'breadcrumbs.product.create',
                                        routeName: 'settings-items'
                                    }
                                ]
                            },
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-items-list'
                                }],
                            requiresPermission: 'users_view'
                        }
                    },
                    {
                        name: "settings-users-permission-view",
                        path: ':id/view',
                        component: () => import('../views/Settings/User/ViewUserPermission.vue'),
                        meta: {
                            title: "setting.users",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'users_permission'
                        }
                    },
                    {
                        // Journal des connexions de la société (sécurité)
                        name: "settings-login-logs",
                        path: "connexions",
                        component: () => import('../views/Settings/User/LoginLogs.vue'),
                        meta: {
                            title: 'login_log.title',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'users_login_log'
                        }
                    },
                    {
                        name: "settings-rights",
                        path: "rights",
                        component: () => import('../views/Settings/Right/Right.vue'),
                        meta: {
                            title: 'setting.rights',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'right_view'
                        }
                    },
                    {
                        name: "settings-rights-view",
                        path: 'settings/rights/:id/view',
                        component: () => import('../views/Settings/Right/RightView.vue'),
                        meta: {
                            title: "setting.rights",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'right_permission_view'
                        }
                    },
                    // ancienne adresse du profil (désormais une page à part)
                    {
                        path: "profil",
                        redirect: { name: 'settings-profile' },
                    },
                    {
                        name: "settings-external-drivers",
                        path: "livreurs-externes",
                        component: () => import('../views/Settings/Livreur/Livreur.vue'),
                        meta: {
                            title: 'setting.external_drivers',
                            requiresPermission: 'external_driver_view',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ]
                        }
                    },
                ]
            },
            {
                name: "settings-system-new",
                path: "settings-product",
                component: () => import('../views/Settings/Layout/BaseSettingProductLayout.vue'),
                children: [
                    {
                        name: "settings-items",
                        path: "",
                        component: () => import('../views/Settings/Items/Index.vue'),
                        meta: {
                            title: 'setting.items_declinations',
                            computedBreadcrumbs: (route) => {
                                return [
                                    {
                                        name: 'breadcrumbs.product.list',
                                        routeName: 'settings-items'
                                    },
                                    {
                                        name: route.query.product ? 'breadcrumbs.product.details' : 'breadcrumbs.product.create',
                                        routeName: 'settings-items'
                                    }
                                ]
                            },
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.product.list',
                                    routeName: 'settings-items-view'
                                }
                            ],
                            requiresPermission: 'product_view'
                        }
                    },
                    {
                        name: "settings-items-view",
                        path: "details",
                        component: () => import('@/views/Settings/Items/Details'),
                        meta: {
                            title: 'setting.items_declinations',
                            computedBreadcrumbs: (route) => {
                                return [
                                    {
                                        name: 'breadcrumbs.product.list',
                                        routeName: 'settings-items-view'
                                    },
                                    {
                                        name: route.query.product ? 'breadcrumbs.product.details' : 'breadcrumbs.product.create',
                                        routeName: 'settings-items-view'
                                    }
                                ]
                            },
                            requiresPermission: 'product_view'
                        }
                    },
                    {
                        name: "settings-categories",
                        path: "categories",
                        component: () => import('@/views/Settings/Category/Category'),
                        meta: {
                            title: 'setting.categories',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'category_view',
                        },
                    },
                    {
                        name: "settings-attributes",
                        path: "attributes",
                        component: () => import('@/views/Settings/Variation/Index'),
                        meta: {
                            title: 'setting.attributes_values',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'variation_view',
                        },
                    },
                    {
                        name: "settings-brands",
                        path: "brands",
                        component: () => import('@/views/Settings/Brand/Brand'),
                        meta: {
                            title: 'setting.brands',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'marque_view',
                        },
                    },
                    {
                        // Options des produits vendus en ligne (accompagnement, suppléments…)
                        name: "settings-product-options",
                        path: "options",
                        component: () => import('@/views/Settings/ProductOptions/Index.vue'),
                        meta: {
                            title: 'product_options.title',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'product_view',
                            requiresModule: 'ecommerce.product_options',
                        },
                    },
                    {
                        // Groupe d'options : page de création / modification
                        name: "settings-product-option-create",
                        path: "options/create",
                        component: () => import('@/views/Settings/ProductOptions/Group.vue'),
                        meta: {
                            title: 'product_options.title',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'product_view',
                            requiresModule: 'ecommerce.product_options',
                        },
                    },
                    {
                        // Groupe d'options : page de création / modification
                        name: "settings-product-option-edit",
                        path: "options/:id/edit",
                        component: () => import('@/views/Settings/ProductOptions/Group.vue'),
                        meta: {
                            title: 'product_options.title',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'product_view',
                            requiresModule: 'ecommerce.product_options',
                        },
                    },
                    {
                        name: "settings-taxes",
                        path: "taxes",
                        component: () => import('@/views/Settings/Tax/Index'),
                        meta: {
                            title: 'setting.taxes',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'taxe_view',
                        },
                    },

                    {
                        name: "bundles-path",
                        path: "bundles",
                        component: BundleIndexView,
                        meta: {
                            title: 'navigation.bundles',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'bundle_view',
                        },
                    },
                    {
                        name: "bundle-edit-path",
                        path: "bundles/:id/edit",
                        component: BundleUpdateView,
                        meta: {
                            title: 'navigation.bundles',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'bundle_update',
                        },
                    },
                    {
                        name: "bundle-create-path",
                        path: "bundles/create",
                        component: BundleUpdateView,
                        meta: {
                            title: 'navigation.bundles',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'bundle_create',
                        },
                    },
                    {
                        name: "settings-lots",
                        path: "lots",
                        component: () => import('@/views/Settings/Lot/Lot'),
                        meta: {
                            title: 'setting.lots',
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'lot_view',
                        },
                    },
                ]
            },
            {
                name: "settings-system-path",
                path: "settings-system",
                component: () => import('../views/Settings/Layout/BaseSettingSystemLayout.vue'),
                children: [
                    {
                        path: '',
                        name: 'society-config',
                        component: SocietyConfigView,
                        meta: {
                            title: "setting.config",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'normalized_invoice_view',
                        }
                    },
                    {
                        path: 'authentication',
                        name: 'setting-system-authentication',
                        component: () => import('@/views/Settings/Society/AuthConfig.vue'),
                        meta: {
                            title: "society.tabs.auth_config",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'system_setting_view',
                        }
                    },
                    {
                        path: 'normalized-invoice',
                        name: 'setting-system-normalized-invoice',
                        component: FactureNormaliseeConfigView,
                        meta: {
                            title: "setting.invoice",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'normalized_invoice_view',
                        }
                    },
                    {
                        path: 'payments',
                        name: 'setting-system-payment',
                        component: () => import('@/views/Settings/Payment/Index'),
                        meta: {
                            title: "setting.payment",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'payment_method_view',
                        }
                    },
                    {
                        path: 'google/recapcha',
                        name: 'recapacha-config',
                        component: () => import('@/views/Settings/Recapcha/Index'),
                        meta: {
                            title: "setting.payment",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'payment_method_view',
                        }
                    },
                    {
                        path: 'currencies',
                        name: 'setting-system-currency',
                        component: () => import('@/views/Settings/Currency/Index'),
                        meta: {
                            title: "setting.currency",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'system_setting_view',
                        }
                    },
                ]
            },
            {
                name: "settings-ecommerce",
                path: "settings-ecommerce",
                component: () => import('../views/Settings/Layout/BaseSettingEcommerceLayout.vue'),
                children: [
                    {
                        path: '',
                        name: 'setting-ecommerce-payment',
                        component: () => import('@/views/Settings/Payment/Index'),
                        meta: {
                            title: "setting.payment",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'payment_method_view',
                            requiresModule: 'ecommerce',
                        }
                    },
                    {
                        path: 'media',
                        name: 'setting-ecommerce-media',
                        component: () => import('@/views/Settings/EcomMedia/Index'),
                        meta: {
                            title: "setting.media",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresModule: 'ecommerce',
                        }
                    },
                    {
                        path: 'mediaList',
                        name: 'setting-ecommerce-mediaList',
                        component: () => import('@/views/Settings/EcomMedia/MediaList'),
                        meta: {
                            title: "setting.mediaList",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'section_view',
                            requiresModule: 'ecommerce',
                        }
                    },
                    {
                        path: 'conditions',
                        component: ConditionIndexView,
                        name: 'setting-system-condition',
                        redirect: { name: 'setting-system-cgv' },
                        children: [
                            {
                                path: 'cgv',
                                name: 'setting-system-cgv',
                                component: () => import('@/views/Settings/Condition/IndexCgv'),
                                meta: {
                                    title: "setting.cgv",
                                    breadcrumbs: [
                                        {
                                            name: 'breadcrumbs.setting.setting',
                                            routeName: 'settings-new'
                                        }
                                    ],
                                    requiresModule: 'ecommerce',
                                requiresPermission: 'general_condition_view',
                                }
                            },
                            {
                                path: 'privacy/policy',
                                name: 'setting-system-privacy',
                                component: () => import('@/views/Settings/Condition/PrivacyPolicy'),
                                meta: {
                                    title: "setting.policy",
                                    breadcrumbs: [
                                        {
                                            name: 'breadcrumbs.setting.setting',
                                            routeName: 'settings-new'
                                        }
                                    ],
                                    requiresModule: 'ecommerce',
                                requiresPermission: 'general_condition_view',
                                }
                            },
                            {
                                path: 'refund/policy',
                                name: 'setting-system-refund-policy',
                                component: () => import('@/views/Settings/Condition/RefundPolicy'),
                                meta: {
                                    title: "setting.refund",
                                    breadcrumbs: [
                                        {
                                            name: 'breadcrumbs.setting.setting',
                                            routeName: 'settings-new'
                                        }
                                    ],
                                    requiresModule: 'ecommerce',
                                requiresPermission: 'general_condition_view',
                                }
                            },
                            {
                                path: 'legal/notice',
                                name: 'setting-system-legal-policy',
                                component: () => import('@/views/Settings/Condition/LegacyMention'),
                                meta: {
                                    title: "setting.refund",
                                    breadcrumbs: [
                                        {
                                            name: 'breadcrumbs.setting.setting',
                                            routeName: 'settings-new'
                                        }
                                    ],
                                    requiresModule: 'ecommerce',
                                requiresPermission: 'general_condition_view',
                                }
                            },
                            {
                                path: 'delivery/delay',
                                name: 'setting-system-delivery-delay',
                                component: () => import('@/views/Settings/Condition/DeliveryDelay'),
                                meta: {
                                    title: "setting.delivery_delay",
                                    breadcrumbs: [
                                        {
                                            name: 'breadcrumbs.setting.setting',
                                            routeName: 'settings-new'
                                        }
                                    ],
                                    requiresModule: 'ecommerce',
                                requiresPermission: 'general_condition_view',
                                }
                            }
                        ]
                    },
                    {
                        path: 'countries',
                        name: 'setting-shipping-countries',
                        component: () => import('@/views/Settings/Country/Index'),
                        meta: {
                            title: "setting.countries",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'country_view',
                            requiresModule: 'ecommerce',
                        }
                    },
                    {
                        path: 'cities',
                        name: 'setting-shipping-cities',
                        component: () => import('@/views/Settings/City/Index'),
                        meta: {
                            title: "setting.cities",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'city_view',
                            requiresModule: 'ecommerce',
                        }
                    },
                    {
                        path: 'areas',
                        name: 'setting-shipping-areas',
                        component: () => import('@/views/Settings/Area/Index'),
                        meta: {
                            title: "setting.areas",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'zone_view',
                            requiresModule: 'ecommerce',
                        }
                    },
                    {
                        name: "setting-shipping-areas-view",
                        path: 'areas/:id/view',
                        component: () => import('../views/Settings/Area/View.vue'),
                        meta: {
                            title: "setting.areas_view",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'zone_detail_view',
                            requiresModule: 'ecommerce',
                        }
                    },
                    {
                        path: 'intervals',
                        name: 'setting-shipping-intervals',
                        component: () => import('@/views/Settings/Interval/Index'),
                        meta: {
                            title: "setting.intervals",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'interval_view',
                            requiresModule: 'ecommerce',
                        }
                    },
                    {
                        path: 'relays',
                        name: 'setting-shipping-relays',
                        component: () => import('@/views/Settings/Relay/Index'),
                        meta: {
                            title: "setting.relays",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'relay_view',
                            requiresModule: 'ecommerce',
                        }
                    },
                    {
                        name: "setting-shipping-relays-view",
                        path: 'relays/:id/view',
                        component: () => import('../views/Settings/Relay/View.vue'),
                        meta: {
                            title: "setting.relays_view",
                            breadcrumbs: [
                                {
                                    name: 'breadcrumbs.setting.setting',
                                    routeName: 'settings-new'
                                }
                            ],
                            requiresPermission: 'relay_interval_view',
                            requiresModule: 'ecommerce',
                        }
                    },
                ]
            },
        ]
    },
    /*
    |--------------------------------------------------------------------------
    | Landlord Routes
    |--------------------------------------------------------------------------|
    */
    {
        path: '/landlord/login',
        name: 'landlord-login',
        component: LandlordLoginView,
        meta: { redirectIfLandlordAuthenticated: true },
    },
    {
        path: '/landlord',
        component: LandlordLayoutView,
        meta: { requiresLandlordAuth: true },
        children: [
            {
                path: 'dashboard',
                component: LandlordDashboardView,
                name: 'landlord-dashboard',
            },
            {
                path: 'shops',
                component: LandlordTenantsIndexView,
                name: 'landlord-shops',
            },
            {
                path: 'shops/create',
                component: LandlordTenantCreateView,
                name: 'landlord-shop-create',
            },
            {
                path: 'shops/:id',
                component: LandlordTenantView,
                name: 'landlord-shop-detail',
            },
            {
                path: 'societies',
                component: LandlordSocietiesIndexView,
                name: 'landlord-societies',
            },
            {
                path: 'societies/:id',
                component: LandlordSocietyView,
                name: 'landlord-society-detail',
            },
            {
                path: 'modules',
                component: LandlordModulesIndexView,
                name: 'landlord-modules',
            },
            {
                path: 'plans',
                component: LandlordPlansIndexView,
                name: 'landlord-plans',
            },
            {
                path: 'plans/:id',
                component: LandlordPlanView,
                name: 'landlord-plan-detail',
            },
            {
                path: 'tickets',
                component: LandlordTicketsIndexView,
                name: 'landlord-tickets',
            },
            {
                path: 'login-logs',
                component: LandlordLoginLogsView,
                name: 'landlord-login-logs',
            },
            {
                path: 'settings',
                component: LandlordSettingsLayoutView,
                name: 'landlord-settings',
                redirect: { name: 'landlord-settings-support' },
                children: [
                    {
                        path: 'support',
                        component: LandlordSettingsSupportView,
                        name: 'landlord-settings-support',
                    },
                    {
                        path: 'whatsapp',
                        component: () => import('../views/Landlord/Settings/Whatsapp.vue'),
                        name: 'landlord-settings-whatsapp',
                    },
                    {
                        path: 'integrations',
                        component: () => import('../views/Landlord/Settings/Integrations.vue'),
                        name: 'landlord-settings-integrations',
                    },
                    {
                        path: 'landing',
                        component: () => import('../views/Landlord/Settings/Landing.vue'),
                        name: 'landlord-settings-landing',
                    },
                ],
            },
        ]
    },
    {
        path: '/admin/permission-denied/403',
        name: 'PermissionDenied',
        component: PermissionDeniedView,
    },
    {
        path: '/subscription-required',
        name: 'subscription-required',
        component: () => import('../views/SubscriptionRequired.vue'),
        meta: { requiresAuth: false },
    },
    {
        // choix et paiement de l'offre (fin d'essai, abonnement expiré) : hors mise en page,
        // ses appels ne passent pas par le contrôle d'abonnement
        path: '/abonnement',
        name: 'subscription-plans',
        component: () => import('../views/SubscriptionPlans.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: NotFoundPageView
    },

    // POS Routes
    {
        path: '/admin/pos',
        component: () => import('@/components/Pos/layout/layout.vue'),
        name: 'pos-caisse-layout',
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                component: () => import('@/views/Pos/new.vue'),
                name: 'pos-caisse-path',
            },
            {
                path: 'payment',
                component: () => import('@/views/Pos/payment.vue'),
                name: 'pos-payment-path',
            },
            {
                path: 'order',
                component: () => import('@/views/Pos/order.vue'),
                name: 'pos-order-path',
            },
            {
                path: 'order-forms',
                component: () => import('@/views/Pos/OrderForms.vue'),
                name: 'pos-order-forms-path',
            },
        ]
    },
    {
        path: '/admin/pos/gestion',
        component: LayoutBasicView,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'sessions',
                component: () => import('@/views/Pos/Session/Index.vue'),
                name: 'pos-session-path',
            },
            {
                path: 'sessions/create',
                component: () => import('@/views/Pos/Session/Create.vue'),
                name: 'pos-session-create-path',
            },
            {
                path: 'sessions/:id/details',
                component: () => import('@/views/Pos/Session/Details.vue'),
                name: 'pos-session-details-path',
                children: [
                    {
                        path: '',
                        component: () => import('@/views/Pos/Session/Sales.vue'),
                        name: 'pos-session-sales-path',
                    },
                    {
                        path: 'sales',
                        component: () => import('@/views/Pos/Session/Sales.vue'),
                        name: 'pos-session-sales-detail-path',
                    },
                    {
                        path: 'products',
                        component: () => import('@/views/Pos/Session/SaleByProduct.vue'),
                        name: 'pos-session-products-path',
                    },
                ]
            },
            {
                path: 'sales',
                component: () => import('@/views/Pos/Sales/Index.vue'),
                name: 'pos-sales-path',
            },
            {
                path: 'sales/:id',
                component: () => import('@/views/Pos/Sales/Details.vue'),
                name: 'pos-sales-details-path',
            },
        ]
    },

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// Boutique visée par un écran, pour le rôle par boutique (null = écran de la société)
function permissionShopFor(to) {
    if (to.matched.some(route => route.name === 'shop-details')) return to.params.id || null
    if (to.path.startsWith('/admin/pos')) return 'active'
    return null
}

router.beforeEach(async (to, from, next) => {

    if (typeof to.matched[0]?.components.default === 'function') {
        window.vueJs?.$emit('asyncComponentLoading', to)
    }

    const isAuthenticated = store.getters['auth/isAuthenticated']

    if (to.matched.some(m => m.meta.requiresAuth) && !isAuthenticated) {
        return next('/login')
    }

    // requiresLandlordAuth était posé sur les routes /admin/landlord/* mais
    // jamais vérifié ici — un accès direct par URL n'était bloqué par aucun
    // garde de navigation, seulement (a posteriori, une fois les appels API
    // lancés) par les 401 renvoyés par le backend.
    if (to.matched.some(m => m.meta.requiresLandlordAuth) && !store.getters['landlordAuth/isAuthenticated']) {
        return next({ name: 'landlord-login' })
    }

    if (to.matched.some(m => m.meta.redirectIfAuthenticated) && isAuthenticated) {
        const { resolveHomeRoute } = await import('@/helpers/homeRoute')
        return next(await resolveHomeRoute())
    }

    // Rôle par boutique (en plus du rôle général) : écrans d'une boutique → son rôle dans cette
    // boutique ; caisse → dans sa boutique active ; écrans de la société → rôle général seul
    const permissionShop = permissionShopFor(to)
    store.commit('permission/SET_CONTEXT_SHOP', permissionShop)

    const meta_permission = to.matched[to.matched.length - 1].meta?.requiresPermission
    if (meta_permission) {
        const permissions = Array.isArray(meta_permission) ? meta_permission : [meta_permission]
        let hasAccess = false
        for (const perm of permissions) {
            try {
                await axios.get(`/permission/${perm}`, { params: permissionShop ? { shop: permissionShop } : {} })
                hasAccess = true
                break
            } catch {}
        }
        if (!hasAccess) {
            // tableau de bord refusé (ex. « /admin » après connexion) : l'accueil plutôt qu'un 403
            if (['dashboard', 'dashboard-path'].includes(to.name)) return next({ name: 'home' })
            return next('/admin/permission-denied/403')
        }
    }

    const meta_module = to.matched[to.matched.length - 1].meta?.requiresModule
    if (meta_module) {
        // Au premier chargement (F5, URL directe), le Vuex store n'a pas encore
        // les modules actifs — ils ne sont chargés que dans LayoutBasic.vue mounted(),
        // qui n'a pas encore tourné à ce stade. Sans ça, ce contrôle échoue toujours
        // sur un rechargement, même quand le module est bien actif.
        if (!store.getters['tenantModule/modules'].length) {
            try {
                await store.dispatch('tenantModule/loadModules')
            } catch {}
        }
        const modules = store.getters['tenantModule/modules']
        const required = Array.isArray(meta_module) ? meta_module : [meta_module]
        const hasModule = required.some(m => modules.includes(m))
        if (!hasModule) return next('/admin/permission-denied/403')
    }

    return next()
})

router.beforeResolve((to, from, next) => {
    window.vueJs.$emit('asyncComponentLoaded') // Stop progress bar
    next()
})

// Pages où la société n'est pas connue (connexion, inscription, connexion Landlord…) :
// elles prennent la couleur de la plateforme, pas celle d'une boutique
router.afterEach((to) => {
    const signedInArea = to.path.startsWith('/admin')
        || (to.path.startsWith('/landlord') && to.name !== 'landlord-login')
    document.body.classList.toggle(PLATFORM_THEMED_CLASS, !signedInArea)
})

export default router
